import { useAppStateSelector } from '../useAppStateSelector'
import { LoadingStates, TeamSimple } from '@dashboard/lib/types'
import { useEffect } from 'react'
import {
  loadTeamSimple,
  showSimpleTeamKey,
} from '@dashboard/store/actions/team/show_simple'
import { useAppDispatch } from '@dashboard/hooks/useAppDispatch'

interface Props {
  state: LoadingStates
  result: TeamSimple | null
  fetch: () => void
}

export function useTeamShowSimple(teamId: string, inviterId?: string): Props {
  const { loadTeamSimpleStates, loadTeamSimpleResults } = useAppStateSelector(
    state => state.team,
  )
  const key = showSimpleTeamKey(teamId, inviterId)
  const state = loadTeamSimpleStates[key] || 'default'
  const result = loadTeamSimpleResults[key] || null
  const dispatch = useAppDispatch()
  const fetch = () => dispatch(loadTeamSimple(teamId, inviterId))

  useEffect(() => {
    if (state === 'default') fetch()
  }, [teamId, state])

  return {
    state,
    result,
    fetch,
  }
}
